import { render, staticRenderFns } from "./SupplierStockPlatformDiscountsComponent.vue?vue&type=template&id=54ba91ad&"
import script from "./SupplierStockPlatformDiscountsComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockPlatformDiscountsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports